import React, { Suspense, useEffect, useState } from "react";
import SuspenseComponent from "../../../views/components/SuspenseComponent";
import DeviceBreadcrumbComponent from "../DeviceBreadcrumbComponent";
import DeviceSaleDoughnut from "./DeviceSaleDoughnut";
import DeviceSaleSubmitDateRange from "./DeviceSaleSubmitDateRange";
import DonationsStatisticsSubmitDateRange from "./DonationsStatisticsSubmitDateRange";
import { useParams } from "react-router-dom";
import { getDeviceSaleByRange, getDonationStats, getDeviceInfo } from "API";
import { useMutation, useQueryClient, useQuery } from "react-query";
import { Row, Col } from "reactstrap";
import useSerialCheck from "hooks/useSerialCheck";
import { useDataDeviceAccess } from "contexts/DataDeviceContext";
import ReactTable from "components/ReactTable/ReactTable.js";

const startOfYesterday = () => {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  d.setHours(0, 0, 0, 0);
  return d;
};

const endOfToday = () => {
  const d = new Date();
  d.setHours(23, 59, 59, 999);
  return d;
};

const DeviceSale = (props) => {
  let { serial } = useParams();
  const userDataDeviceAccess = useDataDeviceAccess();
  const serialFound = useSerialCheck(userDataDeviceAccess, serial);
  const [valueDateRange, setValueDateRange] = useState([startOfYesterday(), endOfToday()]);

  const [valueStatisticsRange, setStatisticsDateRange] = useState([startOfYesterday(), endOfToday()]);

  const [loading, setLoading] = useState(null);
  const [loadingStatistics, setLoadingStatistics] = useState(null);
  const [statistics, setStatistics] = useState([]);
  const [deviceCurrency, setDeviceCurrency] = useState("");

  const handleStatisticsSubmit = () => {
    if (valueStatisticsRange !== null) {
      if (
        valueStatisticsRange[0] instanceof Date &&
        valueStatisticsRange[1] instanceof Date
      ) {
        setLoadingStatistics(true);
        fetchDonationStats({
          serial: serial,
          startRange: valueStatisticsRange[0],
          endRange: valueStatisticsRange[1],
        });
      }
    }
  };

  const queryClient = useQueryClient();
  const handleSubmit = () => {
    if (valueDateRange !== null) {
      if (
        valueDateRange[0] instanceof Date &&
        valueDateRange[1] instanceof Date
      ) {
        setLoading(true);
        mutation({
          serial: serial,
          startRange: valueDateRange[0],
          endRange: valueDateRange[1],
        });
      }
    }
  };

  const { mutate: mutation } = useMutation({
    mutationFn: getDeviceSaleByRange,
    onSuccess: async (newData) => {
      setLoading(false);
      queryClient.setQueryData("Sale", newData);
    },
  });

  const { mutate: fetchDonationStats } = useMutation({
    mutationFn: getDonationStats,
    onSuccess: (newData) => {
      setLoadingStatistics(false);
      setStatistics(newData);
      queryClient.setQueryData("statistics", newData);
    },
  });

  useEffect(() => {
    setLoadingStatistics(true);
    fetchDonationStats({
      serial: serial,
      startRange: valueStatisticsRange[0],
      endRange: valueStatisticsRange[1],
    });
  }, []);

  const handleNull = (data) => {
    if (data === null) {
      return "";
    } else if (data === "Invalid date") {
      return "";
    } else {
      return data;
    }
  };

  const dataInfo = useQuery("Info", () => getDeviceInfo(serial), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      setDeviceCurrency(handleNull(data.data.currency));
    },
  });

  return (
    <>
      <div className="content">
        <Row className="mb-4">
          <Col lg="3">
            <h4>{serialFound !== true ? null : `${serial} Sale`}</h4>
          </Col>
          <Col lg="12">
            <DeviceBreadcrumbComponent
              activePath={"DeviceSale"}
              serial={serial}
            />
          </Col>
        </Row>

        <Row>
          <Col lg="4">
            <DeviceSaleSubmitDateRange
              valueDateRange={valueDateRange}
              setValueDateRange={setValueDateRange}
              handleSubmit={handleSubmit}
            />
            <Suspense fallback={<SuspenseComponent />}>
              <DeviceSaleDoughnut
                loading={loading}
                serial={serial}
                valueDateRange={valueDateRange}
              />
            </Suspense>
          </Col>

          <Col lg="8">
            <DonationsStatisticsSubmitDateRange
              valueDateRange={valueStatisticsRange}
              setValueDateRange={setStatisticsDateRange}
              handleSubmit={handleStatisticsSubmit}
            />

            {loadingStatistics ? (
              <SuspenseComponent />
            ) : (
              <ReactTable
                data={statistics}
                filterable
                resizable={false}
                columns={[
                  {
                    Header: `Donation Amount [${deviceCurrency}`,
                    accessor: "donation_amount",
                  },
                  {
                    Header: "No of donations",
                    accessor: "donation_count",
                  },
                  {
                    Header: "",
                    accessor: "actions",
                    sortable: false,
                    filterable: false,
                  },
                ]}
                defaultPageSize={10}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight mt-4"
              />
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DeviceSale;
